import Header from "components/headerfull";
import { useEffect, useState } from "react";
import '../styles/genericButton.css';
import '../styles/additional.css';
import { RoundBlueOutline, RoundBluePlain, RoundGreyOutline, RoundGreyPlain, RoundWhitePlain } from "components/ui/Buttons/generic/GenericButton";
import { FooterMaximized } from "components/footerfull";
import UniversitiesSlider from "components/universitySlider/UniversitiesSlider";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}


const UNIS= [
    {
        "country": "Afrique du Sud",
        "name": "Université de Cape Town",
        "image_name": "Capetown.svg",
        "image_type": "svg"
    },
    {
        "country": "Inde",
        "name": "Indian Institute of Technology",
        "image_name": "Bombay.svg",
        "image_type": "svg"
    },
    {
        "country": "Madagascar",
        "name": "Université de Fianarantsoa",
        "image_name": "Fianar.png",
        "image_type": "png"
    },
    {
        "country": "Afrique du Sud",
        "name": "Université de Witwatersrand",
        "image_name": "Witwatersrand.png",
        "image_type": "png"
    },
    {
        "country": "Madagascar",
        "name": "Faculté EGS Antananarivo",
        "image_name": "EGS.png",
        "image_type": "png"
    },
    {
        "country": "Nigéria",
        "name": "Université d'Ibadan",
        "image_name": "Ibadan.png",
        "image_type": "png"
    },
    {
        "country": "Nigéria",
        "name": "Université de Lagos",
        "image_name": "Lagos.svg",
        "image_type": "svg"
    },
    {
        "country": "Maroc",
        "name": "Université Mohammed V",
        "image_name": "Mohammed.png",
        "image_type": "png"
    },
    {
        "country": "Ouganda",
        "name": "Université de Makerere",
        "image_name": "Makerere.png",
        "image_type": "png"
    },
    {
        "country": "Sénégal",
        "name": "Université Cheikh Anta Diop (UCAD)",
        "image_name": "UCAD.png",
        "image_type": "png"
    },
    {
        "country": "Inde",
        "name": "Université de Delhi",
        "image_name": "Delhi.png",
        "image_type": "png"
    }
];

gsap.registerPlugin(ScrollTrigger);


export default function CommentCaMarche({isFreelance= false}: any){

    /*Animation*/
    useGSAP(()=>{
        const slideSiders= gsap.utils.toArray('.from-side');
        slideSiders.forEach((element: any) => {
            const side= element.getAttribute("data-slide-from")=== "0" ? -1 : 1;
            gsap.from(element, {
                x: side * 50,
                opacity: 0,
                duration: 0.8,
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                    toggleActions: "play none play reverse"
                }
            });
        });

        gsap.from(".com-fade-in", {
            y: 50,
            opacity: 0,
            stagger: 0.2,
            duration: 0.8,
            scrollTrigger: {
                trigger: ".com-fade-in",
                start: "top 90%",
                toggleActions: "play none play reverse"
            }
        });
    }, []);
    /*Animation END*/

    const [freelanceState, setFreelanceState]= useState(isFreelance?"true":"false");

    useEffect(()=> {
        document.title= isFreelance ? "Guide freelances - Wall of Share" : "Comment Wall of Share fonctionne pour entreprises";
        const desc= isFreelance ? "Apprenez comment Wall of Share aide les freelances à trouver des missions pertinentes et à travailler avec des entreprises innovantes." : "Découvrez comment trouver rapidement les meilleurs freelances pour vos projets avec Wall of Share, la solution pour recruter facilement en ligne.";
        setDescription(desc);
    },[]);
    
    return (
        <>
            <Header type="default" />

            <HeaderBanner isFreelance={isFreelance} key={freelanceState}/>
            <div className={isFreelance? "w-full half-grey" : "w-full half-blue"}>
                <CallToAction isFreelance={isFreelance}/>
            </div>
            {
                !isFreelance
                    &&
                    <div className="w-full bg-transparent py-[3rem] pb-[4.5rem]">
                        <UniversitiesSlider UNIS={UNIS} bigMargin={false}/>
                    </div>
            }

            <PayementComponent isFreelance={isFreelance} />

            <ContactUs isFreelance={isFreelance} />
            
            <FooterMaximized />
        </>
    );
};

const HeaderBanner= ({isFreelance= false}: any)=> {
    return (
        <div className="bg-primary-blue w-full">
            <div className="bg-center relative bg-cover bg-norepeat md:p-[113px] md:px-[113px] px-[5%] h-[784px] pt-[113px] flex flex-col gap-[2rem] items-center" style={{backgroundImage: `url('comment-ca/comment-ca-marche-banner.webp')`}}>
                {
                    isFreelance?
                    <RoundGreyOutline text="Vous êtes un freelance" className="md:leading-[32.5px] md:text-[25px] text-[18px] leading-[23.44px] md:px-[40px] md:py-[15.5px] px-[51.5px] py-[10px] font-dm-sans relative font-bold" noCursor={true}/>
                    :
                    <RoundBlueOutline text="Vous êtes une entreprise" className="md:leading-[32.5px] md:text-[25px] text-[18px] leading-[23.44px] md:px-[40px] md:py-[15.5px] px-[51.5px] py-[10px] font-dm-sans relative font-bold" noCursor={true}/>
                }
                <div className="absolute top-0 left-0 w-full h-full z-[0]" style={{backgroundImage: `${isFreelance ? 'linear-gradient(0deg, #f4f4f5ff 20%, #f4f4f566 100%' : 'linear-gradient(0deg, #1D1D39ff 20%, #1D1D39e5 100%'})`}}>
                </div>
                <h1
                    className={ isFreelance ?
                        "lg:text-[60px] lg:leading-[60px] text-[30px] leading-[30px] text-center font-semibold relative z-[2] text-primary-blue"
                        :
                        "lg:text-[60px] lg:leading-[60px] text-[30px] leading-[30px] text-center font-semibold relative z-[2] text-white"}
                >Comment ça marche ?</h1>
                <p
                    className={isFreelance ?
                        "text-[18px] leading-[23.44px] md:text-[22px] md:leading-[28.64px] font-normal font-dm-sans relative z-[2] text-[#515151] text-center max-w-[1024px]"
                        :
                        "text-[18px] leading-[23.44px] md:text-[22px] md:leading-[28.64px] font-normal font-dm-sans relative z-[2] text-[#bbbbc4] text-center max-w-[1024px]"}
                >
                    {
                        isFreelance ?
                        <>Suivez ces étapes simples pour maximiser vos opportunités et accéder à des missions de qualité avec Wall-of-Share.</>
                        :
                        <>Découvrez un processus simple et rapide pour trouver les meilleurs talents et gérer vos projets en toute sérénité, de la publication de votre mission à sa réalisation.</>
                    }
                </p>
            </div>

            <div className={isFreelance ? "bg-[#f4f4f5] items-center relative more-on-the-bottom freel" : "bg-primary-blue items-center relative more-on-the-bottom"}>
                {/* <div className="md:max-w-[834px] md:min-w-[760px] md:w-[90%] w-full lg:h-[970px] absolute z-[2] steps-graph top-[-20rem] left-[50%] transform translate-x-[-50%]"> */}
                <div className="md:max-w-[834px] md:min-w-[760px] md:w-[90%] w-full md:h-[970px] h-max absolute z-[2] steps-graph md:top-[-20rem] top-[-24rem] left-[50%] transform translate-x-[-50%]">
                    <div className={`${!isFreelance ? 'from-side bg-[#F4F4F5]' : 'from-side bg-primary-blue'} px-[30px] md:py-[50px] py-[20px] rounded-[2rem] max-w-[365px] h-max one flex flex-col md:gap-[16px] gap-[6px]`} data-slide-from="0">
                        <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O1</div>
                        <h2
                            className={isFreelance ?
                                'font-bold text-white text-[22px] leading-[26.4px]'
                                :
                                'font-bold text-primary-blue text-[22px] leading-[26.4px]'}
                        >
                            {
                                !isFreelance ?
                                    (
                                        <>Créez votre compte et publiez votre mission rapidement</>
                                    ) : (
                                        <>Créez votre compte et démarquez-vous avec un profil complet</>
                                    )
                            }
                        </h2>
                        <div
                            className={isFreelance ?
                                'text-[#bbbbc4] font-normal text-[18px] leading-[23.44px] font-dm-sans'
                                :
                                'text-[#6F6F6F] font-normal text-[18px] leading-[23.44px] font-dm-sans'}
                        >
                            {
                                !isFreelance ?
                                    (
                                        <>Un processus d'inscription simplifié pour vous permettre de publier votre première mission en quelques minutes seulement.</>
                                    ) : (
                                        <>Un profil soigné et complet augmente vos chances d'être sélectionné pour des projets de qualité. Inscrivez-vous et attirez les entreprises qui recherchent vos compétences.</>
                                    )
                            }
                        </div>
                    </div>

                    <div className={`${!isFreelance ? 'from-side bg-[#F4F4F5]' : 'from-side bg-primary-blue'} px-[30px] md:py-[50px] py-[20px] rounded-[2rem] max-w-[365px] h-max two flex flex-col md:gap-[16px] gap-[6px]`} data-slide-from="1">
                        <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O2</div>
                        <h2 className={isFreelance ?
                                'font-bold text-white text-[22px] leading-[26.4px]'
                                :
                                'font-bold text-primary-blue text-[22px] leading-[26.4px]'}
                        >
                            {
                                !isFreelance  ?
                                    (
                                        <>Accédez à des freelances qualifiés en un temps record</>
                                    ) : (
                                        <>Découvrez des missions de qualité avec des entreprises sérieuses</>
                                    )
                            }
                        </h2>
                        <div className={isFreelance ?
                                'text-[#bbbbc4] font-normal text-[18px] leading-[23.44px] font-dm-sans'
                                :
                                'text-[#6F6F6F] font-normal text-[18px] leading-[23.44px] font-dm-sans'}
                        >
                            {
                                !isFreelance  ?
                                    (
                                        <>Explorez une sélection de freelances triés sur le volet, correspondant parfaitement à vos besoins. Consultez les profils, évaluez les compétences et choisissez vos talents idéaux.</>
                                    ) : (
                                        <>Accédez à des projets soigneusement vérifiés et proposés par des entreprises sérieuses qui valorisent votre expertise et sont prêtes à payer le juste prix pour des résultats exceptionnels.</>
                                    )
                            }

                        </div>
                    </div>

                    <div className={`${!isFreelance ? 'from-side bg-[#F4F4F5]' : 'from-side bg-primary-blue'} px-[30px] md:py-[50px] py-[20px] rounded-[2rem] max-w-[365px] h-max three flex flex-col md:gap-[16px] gap-[6px]`} data-slide-from="0">
                        <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O3</div>
                        <h2 className={isFreelance ?
                                'font-bold text-white text-[22px] leading-[26.4px]'
                                :
                                'font-bold text-primary-blue text-[22px] leading-[26.4px]'}
                        >
                            {
                                !isFreelance  ?
                                    (
                                        <>Suivi de projet simplifié avec gestion automatisée</>
                                    ) : (
                                        <>Développez votre carrière avec des opportunités exclusives </>
                                    )
                            }
                        </h2>
                        <div className={isFreelance ?
                                'text-[#bbbbc4] font-normal text-[18px] leading-[23.44px] font-dm-sans'
                                :
                                'text-[#6F6F6F] font-normal text-[18px] leading-[23.44px] font-dm-sans'}
                        >
                            {
                                !isFreelance  ?
                                    (
                                        <>Gestion de contrats, paiements sécurisés et suivi de mission – tout est géré sur notre plateforme pour vous garantir une expérience fluide.</>
                                    ) : (
                                        <>Accédez à des projets variés et de haute qualité qui vous permettent de renforcer vos compétences et de bâtir une solide réputation.</>
                                    )
                            }

                        </div>
                    </div>
                    <div className="dot f-one md:block hidden"></div>
                    <div className="dot f-two md:block hidden"></div>
                    <div className="dot f-three md:block hidden"></div>
                </div>
                <div className={isFreelance? "w-full bg-transparent md:py-[6rem] py-[8rem] pb-[10rem] move-out flex flex-col items-center" : "w-full bg-transparent md:py-[6rem] py-[3rem] pb-[10rem] move-out flex flex-col items-center"}>
                    {
                    isFreelance ?
                        <RoundGreyPlain text="Inscrivez vous maintenant" to={"/parcours-freelance"} isButton={false} className="py-[16px] md:px-[40px] px-[20px] text-[20px] leading-[26.04px]"/>
                        :
                        <RoundBluePlain text="Publiez votre projet dès maintenant" to={"/parcours-entreprise"} isButton={false} className="py-[16px] md:px-[40px] px-[20px] text-[20px] leading-[26.04px]"/>
                    }
                </div>
            </div>
        </div>
    );
};

const CallToAction = ({isFreelance}: any) => {
    return (
        <div className={`${!isFreelance ? 'com-fade-in-trigger bg-[#F4F4F5]' : 'com-fade-in-trigger bg-primary-blue'} rounded-3xl flex justify-center lg:w-3/4 w-5/6 max-w-[1071px] mx-auto lg:px-[6.2em] px-[2em] py-14 lg:min-w-[900px]`}>
            <div className=" flex gap-[3em] flex-col lg:flex-row items-center justify-center">
                <div className="max-w-[500px] rounded-3xl overflow-hidden lg:w-[65rem] md:w-[500px] w-full relative lg:h-full h-[300px] bg-cover bg-norepeat bg-center lg:flex-[1]" style={{ backgroundImage: `${!isFreelance ? "url('/about-images/about-03.webp')" : "url('/acceuil-images/action-02.webp')" }` }}>
                </div>
                <div className={`space-y-3 ${!isFreelance ? '' : 'text-white'} flex flex-col justify-between lg:flex-[1.3]`}>
                    <div className="relative">
                        <div className="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 md:text-[30px] md:leading-[36px] text-[18px] leading-[21px] font-semibold com-fade-in">
                            {
                                isFreelance ? 'Vous êtes un freelance ?' : 'Vous êtes une entreprise ?'
                            }
                        </div>
                    </div>
                    <div className="font-semibold md:text-[35px] md:leading-[42px] text-[25px] leading-[30px] com-fade-in">
                        {
                            isFreelance ?
                                'Mettez en valeur vos compétences !' :
                                'Confiez votre projet à Wall of Share !'
                        }

                    </div>
                    <div className={isFreelance? "text-[#ddddf499] font-normal text-[19px] leading-[26px] w-full font-dm-sans com-fade-in" : "text-[#6f6f6f] font-normal text-[20px] leading-[26px] w-full font-dm-sans com-fade-in"}>
                        {
                            isFreelance ? "Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent." :
                                "Avec Wall of Share, rencontrez le talent qui correspond exactement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis."
                        }
                    </div>

                    <div className="pt-1 com-fade-in">
                        {
                            isFreelance ?
                            <RoundBluePlain text="Inscrivez-vous" isButton={false} to="/inscription-freelances" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
                            :
                            <RoundGreyPlain text="Inscrivez-vous" isButton={false} to="/inscription-entreprises" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]"  />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export const ContactUs= ({isFreelance= false}: any) => {
    return (
        <div className={isFreelance ? "w-full py-[108px] bg-[#f4f4f5]" : "w-full py-[108px] bg-white"}>
            <div className="flex flex-col justify-center items-center gap-[30px] lg:w-3/5 md:w-2/3 w-5/6 mx-auto">
                <div className="font-semibold text-h2 text-primary-blue">Contactez-nous</div>
                <p className="text-center text-[#6F6F6F] font-medium text-xl font-dm-sans">Pour toute question ou pour en savoir plus sur Wall Of Share, <br className="hidden lg:inline"/>n'hésitez pas à nous contacter. Nous sommes là pour vous aider</p>
				{
					isFreelance ?
						<RoundGreyPlain text="Nous contacter" isButton={false} to={"/contactez-nous"} className="px-[27px] py-[13.5px] text-[18px] leading-[23px]" />
						:
						<RoundWhitePlain text="Nous contacter" isButton={false} to={"/contactez-nous"} className="px-[27px] py-[13.5px] text-[18px] leading-[23px]" />
				}
            </div>
        </div>
    );
};

export const PayementComponent= ({isFreelance= false}: any) => {
    return (
        <div className={isFreelance ? "w-full bg-[white] py-[7rem]" : "w-full bg-[#f4f4f5] py-[99px]"}>
            <div className={`flex flex-col items-center lg:flex-row gap-4 lg:w-3/4 md:w-5/6 w-full max-w-[1071px] mx-auto`}>
                <div className="flex flex-col gap-[1.5rem]">
                    <div className="lg:text-[40px] text-[30px] lg:leading-[48px] leading-[36px] text-primary-blue font-semibold lg:text-left text-center md:w-full w-5/6 mx-auto">Des paiements sécurisés, adaptés à vos besoins.</div>
                    <p className="lg:text-[22px] text-[18px] lg:leading-[28.64px] leading-[23.44px] text-[#6f6f6f] font-normal font-dm-sans lg:text-left text-center md:w-full w-5/6 mx-auto">Une sélection de solutions de paiement fiables pour des transactions simplifiées.</p>
                </div>
                <div className="md:flex flex-row flex-wrap md:gap-[1rem] gap-[2rem] gap-y-[.5rem] md:justify-center justify-around hidden">
                    <img src="/comment-ca/paypal.svg" alt="PAYPAL_LOGO" />
                    <img src="/comment-ca/mercado.svg" alt="MERCADO_LOGO" />
                    <img src="/comment-ca/payoneer.svg" alt="PAYONEER_LOGO" />
                    <img src="/comment-ca/payU.svg" alt="PAY_U_LOGO" />
                    <img src="/comment-ca/astropay.svg" alt="ASTROPAY_LOGO" />
                    <img src="/comment-ca/american.svg" alt="AMERICAN_EXPRESS_LOGO" />
                    <img src="/comment-ca/visa.svg" alt="VISA_LOGO" />
                    <img src="/comment-ca/mastercard.svg" alt="MASTERCARD_LOGO" />
                    <img src="/comment-ca/gie.svg" alt="GIE_LOGO" />
                    <img src="/comment-ca/verto.svg" alt="VERTO_LOGO" />
                </div>
		<div className="md:hidden flex flex-col gap-[25px] w-full" >
			<div className="flex flex-row justify-center items-center flex-wrap gap-[10px]">
                    		<img src="/comment-ca/paypal.svg" alt="PAYPAL_LOGO" />
                    		<img src="/comment-ca/mercado.svg" alt="MERCADO_LOGO" />
                    		<img src="/comment-ca/payoneer.svg" alt="PAYONEER_LOGO" />
			</div>
			<div className="flex flex-row justify-center items-center flex-wrap gap-[10px]">
                    		<img src="/comment-ca/american.svg" alt="AMERICAN_EXPRESS_LOGO" />
                    		<img src="/comment-ca/visa.svg" alt="VISA_LOGO" />
                    		<img src="/comment-ca/mastercard.svg" alt="MASTERCARD_LOGO" />
                    		<img src="/comment-ca/gie.svg" alt="GIE_LOGO" />
                    		<img src="/comment-ca/payU.svg" alt="PAY_U_LOGO" />
			</div>
			<div className="flex flex-row justify-around items-center gap-[25px] mx-auto flex-wrap">
                    		<img src="/comment-ca/astropay.svg" alt="ASTROPAY_LOGO" />
                    		<img src="/comment-ca/verto.svg" alt="VERTO_LOGO" />
			</div>
		</div>
            </div>
        </div>
    );
};